import React, { useState, useEffect } from "react";
import ExpandableSection from "../../expandablesection";
import Quantity from "./Quantity";
import DoorSize from "./DoorSize";
import DoorHeight from "./DoorHeight";
import FrameWidth from "./FrameWidth";
import FrameHeight from "./FrameHeight";
import Jambs from "./Jambs";
import JambMaterial from "./JambMaterial";
import FrameExtension from "./FrameExtension";
import OverrideExtension from "./OverrideExtension";
import Swing from "./Swing";
import Hinges from "./Hinges";
import HingeFinish from "./HingeFinish";
import DecorativeTips from "./DecorativeTips";
import OperatingSideLite from "./OperatingSideLite";
import MultipointPrep from "./MultipointPrep";
import DeadboltHole from "./DeadboltHole";
import PassagePrep from "./PassagePrep";
import WeatherStrip from "./WeatherStrip";
import WeatherStripColor from "./WeatherStripColor";
import Flex from "./Flex";
import EnergyStarGlass from "./EnergyStarGlass";
import SecurityWindowFilm from "./SecurityWindowFilm";
import LaminatedGlass from "./LaminatedGlass";
import { forwardRef, useImperativeHandle } from 'react';

const PanelFrame = forwardRef(({ onChange, passSelectedDoor/*,
                                           doorSizeValueTriggered, 
                                           doorHeightValueTriggered,                                   
                                           setDoorSizeValueT, 
                                           setDoorHeightValueT*/  
 }, ref) => {
//const PanelFrame = ({ onChange, passSelectedDoor }) => {
  const [quantityValue, setQuantityValue] = useState("");

  const [doorSizeValue, setDoorSizeValue] = useState(/*doorSizeValueTriggered||*/"");
  const [doorHeightValue, setDoorHeightValue] = useState(/*doorHeightValueTriggered||*/"");

  const [frameWidthValue, setFrameWidthValue] = useState("");
  const [frameHeightValue, setFrameHeightValue] = useState("");
  const [jambsValue, setJambsValue] = useState("");
  const [jambMaterialValue, setJambMaterialValue] = useState("");
  const [frameExtensionValue, setFrameExtensionValue] = useState("");
  const [overrideExtensionValue, setOverrideExtensionValue] = useState(""); 
  const [swingValue, setSwingValue] = useState("");
  const [hingesValue, setHingesValue] = useState("");
  const [hingeFinishValue, setHingeFinishValue] = useState("");
  const [decorativeTipsValue, setDecorativeTipsValue] = useState("");
  const [operatingSideLiteValue, setOperatingSideLiteValue] = useState("");
  const [multipointPrepValue, setMultipointPrepValue] = useState("");
  const [deadboltHoleValue, setDeadboltHoleValue] = useState("");
  const [passagePrepValue, setPassagePrepValue] = useState("");
  const [weatherStripValue, setWeatherStripValue] = useState("");
  const [weatherStripColorValue, setWeatherStripColorValue] = useState("");
  const [flexValue, setFlexValue] = useState("");
  const [energyStarGlassValue, setEnergyStarGlassValue] = useState("");
  const [securityWindowFilmValue, setSecurityWindowFilmValue] = useState("");
  const [laminatedGlassValue, setLaminatedGlassValue] = useState("");

  // Method to retrieve all active controls and their values
  const getActiveControlsWithValues = () => {
    const values = {};

    controlMap
      .filter((control) => control.status === "active") // Only active controls
      .forEach((control) => {
        const element = document.getElementById(control.id); // Query by control ID
        if (element) {
          values[control.id] = element.value; // Retrieve the current value
        } else {
          values[control.id] = null; // Handle missing elements
        }
      });

    return values;
  };

  // Expose the `getActiveControlsWithValues` method to the parent via ref
  useImperativeHandle(ref, () => ({
    getActiveControlsWithValues,
  }));

  // Notify parent component whenever values change
  useEffect(() => {
    const data = {
      quantity: quantityValue,
      doorSize: doorSizeValue, doorHeight: doorHeightValue,
      frameWidth: frameWidthValue, frameHeight: frameHeightValue,
      jambs: jambsValue, jambMaterial: jambMaterialValue,
      frameExtension: frameExtensionValue, overrideExtension:overrideExtensionValue,
      swing: swingValue, hinges: hingesValue, hingeFinish: hingeFinishValue,
      decorativeTips: decorativeTipsValue,
      operatingSideLite: operatingSideLiteValue,
      multipointPrep: multipointPrepValue, deadboltHole: deadboltHoleValue, passagePrep: passagePrepValue,
      weatherStrip: weatherStripValue, weatherStripColor: weatherStripColorValue, flex: flexValue,
      energyStarGlass: energyStarGlassValue, securityWindowFilm: securityWindowFilmValue, laminatedGlass: laminatedGlassValue,
    };
    console.log("PanelFrame triggering onChange with:", data);
    onChange(data);
  }, [
      quantityValue,
      doorSizeValue, doorHeightValue, 
      frameWidthValue, frameHeightValue,
      jambsValue, jambMaterialValue, 
      frameExtensionValue, overrideExtensionValue, 
      swingValue, hingesValue, hingeFinishValue,
      decorativeTipsValue, 
      operatingSideLiteValue,
      multipointPrepValue, deadboltHoleValue, passagePrepValue, 
      weatherStripValue, weatherStripColorValue, flexValue, 
      energyStarGlassValue, securityWindowFilmValue, laminatedGlassValue, 
      onChange]);

    const handleDoorSizeChange = React.useCallback((newValue) => {
      setDoorSizeValue(newValue);    // Update local state
    /*  if (setDoorSizeValueT) {     
          console.log("from handleDoorSizeChange 1", setDoorSizeValueT, "doorSizeValueTriggered",doorSizeValueTriggered,"newValue", newValue);   
          setDoorSizeValueT(newValue); // Notify parent
          console.log("from handleDoorSizeChange 2", setDoorSizeValueT, "doorSizeValueTriggered",doorSizeValueTriggered,"newValue", newValue);   
      }*/
    }, []); // Empty dependency array ensures it won't be recreated

    const handleDoorHeightChange = React.useCallback((newValue) => {
      setDoorHeightValue(newValue);    // Update local state
     /* if (setDoorHeightValueT) {
          setDoorHeightValueT(newValue); // Notify parent
      }*/
    }, []); // Empty dependency array ensures it won't be recreated
/*
    useEffect(() => {
      if (doorSizeValueTriggered !== undefined) {
          setDoorSizeValue(doorSizeValueTriggered); // Sync with parent state
      }
    }, [doorSizeValueTriggered]);

    useEffect(() => {
      if (doorHeightValueTriggered !== undefined) {
          setDoorHeightValue(doorHeightValueTriggered); // Sync with parent state
      }
    }, [doorHeightValueTriggered]);
*/

   // Control map specific to FramePanel
   const controlMap = [
    {
      id: "Quantity",
      component: (
        <Quantity
          value={quantityValue}
          onChange={(newValue) => {
            setQuantityValue(newValue);
          }}
        />
      ),
      position: [1, 1],
      status: "active",
      expandableSectionId: "FramePanel",
    },
    {
      id: "DoorSize",
      component: (
        <DoorSize
 
          value={doorSizeValue}
          onChange={(newValue) => {
            setDoorSizeValue(newValue);
          }}
          //onChange={handleDoorSizeChange}
        />
      ),
      position: [2, 1],
      status: "active",
      expandableSectionId: "FramePanel",
    },
    {
      id: "DoorHeight",
      component: (
          <DoorHeight
          onChange={(newValue) => {
            setDoorHeightValue(newValue);
          }}
          value={doorHeightValue}
          //onChange={handleDoorHeightChange}
        />
      ),
      position: [2, 2],
      status: "active",
      expandableSectionId: "FramePanel",
    },
    {
      id: "FrameWidth",
      component: (
        <FrameWidth
 
          value={frameWidthValue}
          onChange={(newValue) => {
            setFrameWidthValue(newValue);
          }}
          doorSizeValue={doorSizeValue} 
          doorHeightValue={doorHeightValue} 
          passSelectedDoor={passSelectedDoor}
        />
      ),
      position: [3, 1],
      status: "active",
      expandableSectionId: "FramePanel",
    },
    {
      id: "FrameHeight",
      component: (
        <FrameHeight
  
          value={frameHeightValue}
          onChange={(newValue) => {
            setFrameHeightValue(newValue);
          }}
          doorSizeValue={doorSizeValue} 
          doorHeightValue={doorHeightValue} 
          passSelectedDoor={passSelectedDoor}
        />
      ),
      position: [3, 2],
      status: "active",
      expandableSectionId: "FramePanel",
    },
    {
        id: "Jambs",
        component: (
          <Jambs

            value={jambsValue}
            onChange={(newValue) => {
              setJambsValue(newValue);
            }}
          />
        ),
        position: [4, 1],
        status: "active",
        expandableSectionId: "FramePanel",
      },
      {
        id: "JambMaterial",
        component: (
          <JambMaterial
 
          value={jambMaterialValue}
            onChange={(newValue) => {
              setJambMaterialValue(newValue);
            }}
          />
        ),
        position: [4, 2],
        status: "active",
        expandableSectionId: "FramePanel",
      },
      {
        id: "FrameExtension",
        component: (
          <FrameExtension
 
            value={frameExtensionValue}
            onChange={(newValue) => {
              setFrameExtensionValue(newValue);
            }}
            childs={["OverrideExtension" ]}
          />
        ),
        position: [5, 1],
        status: "active",
        expandableSectionId: "FramePanel",
      },
      {
        id: "OverrideExtension",
        component: (
          <OverrideExtension
  
            value={overrideExtensionValue}
            onChange={(newValue) => {
              setOverrideExtensionValue(newValue);
            }}
          />
        ),
        position: [5, 2],
        status: "active",
        expandableSectionId: "FramePanel",
      },   
    {
      id: "Swing",
      component: (
        <Swing

          value={swingValue}
          onChange={(newValue) => {
            setSwingValue(newValue);
          }}
        />
      ),
      position: [6, 1],
      status: "active",
      expandableSectionId: "FramePanel",
    },   
    {
      id: "Hinges",
      component: (
        <Hinges

          value={hingesValue}
          onChange={(newValue) => {
            setHingesValue(newValue);
          }}
          passSelectedDoor={passSelectedDoor}
        />
      ),
      position: [6, 2],
      status: "active",
      expandableSectionId: "FramePanel",
    },   
    {
      id: "HingeFinish",
      component: (
        <HingeFinish

          value={hingeFinishValue}
          onChange={(newValue) => {
            setHingeFinishValue(newValue);
          }}
          swingValue={swingValue}
        />
      ),
      position: [6, 3],
      status: "active",
      expandableSectionId: "FramePanel",
    },   
      {
        id: "DecorativeTips",
        component: (
          <DecorativeTips
  
            value={decorativeTipsValue}
            onChange={(newValue) => {
              setDecorativeTipsValue(newValue);
            }}
          />
        ),
        position: [7, 1],
        status: "active",
        expandableSectionId: "FramePanel",
      },  
      {
        id: "OperatingSideLite",
        component: (
          <OperatingSideLite
   
            value={operatingSideLiteValue}
            onChange={(newValue) => {
              setOperatingSideLiteValue(newValue);
            }}
          />
        ),
        position: [8, 1],
        status: "active",
        expandableSectionId: "FramePanel",
      },
      {
        id: "MultipointPrep",
        component: (
          <MultipointPrep
  
            value={multipointPrepValue}
            onChange={(newValue) => {
              setMultipointPrepValue(newValue);
            }}
            childs={["DeadboltHole", "PassagePrep" ]}
          />
        ),
        position: [9, 1],
        status: "active",
        expandableSectionId: "FramePanel",
      },
      {
        id: "DeadboltHole",
        component: (
          <DeadboltHole
  
            value={deadboltHoleValue}
            onChange={(newValue) => {
              setDeadboltHoleValue(newValue);
            }}
            passSelectedDoor={passSelectedDoor}
          />
        ),
        position: [9, 2],
        status: "active",
        expandableSectionId: "FramePanel",
      },   
      {
        id: "PassagePrep",
        component: (
          <PassagePrep

            value={passagePrepValue}
            onChange={(newValue) => {
              setPassagePrepValue(newValue);
            }}
            passSelectedDoor={passSelectedDoor}
          />
        ),
        position: [9, 3],
        status: "active",
        expandableSectionId: "FramePanel",
      },   
      {
        id: "WeatherStrip",
        component: (
          <WeatherStrip

            value={weatherStripValue}
            onChange={(newValue) => {
              setWeatherStripValue(newValue);
            }}
          />
        ),
        position: [10, 1],
        status: "active",
        expandableSectionId: "FramePanel",
      },   
      {
        id: "WeatherStripColor",
        component: (
          <WeatherStripColor
 
            value={weatherStripColorValue}
            onChange={(newValue) => {
              setWeatherStripColorValue(newValue);
            }}
          />
        ),
        position: [10, 2],
        status: "active",
        expandableSectionId: "FramePanel",
      },    
      {
        id: "Flex",
        component: (
          <Flex

            value={flexValue}
            onChange={(newValue) => {
              setFlexValue(newValue);
            }}
          />
        ),
        position: [10, 3],
        status: "active",
        expandableSectionId: "FramePanel",
      },  
      {
        id: "EnergyStarGlass",
        component: (
          <EnergyStarGlass
  
            value={energyStarGlassValue}
            onChange={(newValue) => {
              setEnergyStarGlassValue(newValue);
            }}
          />
        ),
        position: [11, 1],
        status: "active",
        expandableSectionId: "FramePanel",
      },    
      {
        id: "SecurityWindowFilm",
        component: (
          <SecurityWindowFilm
 
            value={securityWindowFilmValue}
            onChange={(newValue) => {
              setSecurityWindowFilmValue(newValue);
            }}
          />
        ),
        position: [11, 2],
        status: "active",
        expandableSectionId: "FramePanel",
      },   
      {
        id: "LaminatedGlass",
        component: (
          <LaminatedGlass

            value={laminatedGlassValue}
            onChange={(newValue) => {
              setLaminatedGlassValue(newValue);
            }}
          />
        ),
        position: [11, 3],
        status: "active",
        expandableSectionId: "FramePanel",
      },   
];

const addRightQuote = (value) => {
  // Check if value already ends with a quote, if so, return it as is
  if (value && value.endsWith('"')) {
    return value;
  }

  // Otherwise, add a quote at the end
  return `${value}"`;
};
return (
  <ExpandableSection
    title={`Sizing & Frame${doorSizeValue ? ` (${addRightQuote(doorSizeValue)} x ${addRightQuote(doorHeightValue)})` : ""}`}
    state="true"
    panelLocation="1111"
    controlMap={controlMap.filter((control) => control.expandableSectionId === "FramePanel")}
  />
);
});
//);
//};

export default PanelFrame;
